import React, { useRef, useState } from 'react'

import InputText from '../input-text/input-text'
import inputProptypes from '../input-proptype'
import * as EmailUtility from '@components/utilities/email-utility'
import useEvents from '@components/utilities/event-hooks-utility'
import { useInitialValueToValidation } from '../custom-hooks'

const InputEmail = ({ value, onBlur, errorMessage, onChange, required, ...rest }) => {
  const [currentMessage, setCurrentMessage] = useState(errorMessage)

  const thisInput = useRef(null)
  const defaultEvents = useEvents(thisInput)

  const validateEmail = value => {
    setCurrentMessage('')
    if (!required && !value?.length) return
    if (!EmailUtility.validateEmail(value)) setCurrentMessage('Email inválido.')
  }

  const handleOnChange = defaultEvents.useOnChange(async ({ value, id, name }) => {
    if (onChange) await onChange({ value, id, name })

    return value
  })

  const handleOnBlur = value => {
    validateEmail(value)
    if (onBlur) onBlur(value)
  }

  let inputProps = {
    onBlur: handleOnBlur,
    errorMessage: currentMessage,
    onChange: handleOnChange,
    onKeyUp: defaultEvents.onKeyUp,
    inputRef: thisInput,
    required,
    // type: 'email',
    value,
    ...rest,
  }

  useInitialValueToValidation(value, () => {
    if (!value) return

    validateEmail(value)
  })

  return <InputText {...inputProps} />
}

InputEmail.propTypes = inputProptypes

export default InputEmail
